export const blockIconsSearchGarage = (
	<span className='material-symbols-outlined'>garage</span>
);
